import { render, staticRenderFns } from "./IdeaCoach.vue?vue&type=template&id=3c33d654&scoped=true&"
import script from "./IdeaCoach.vue?vue&type=script&lang=js&"
export * from "./IdeaCoach.vue?vue&type=script&lang=js&"
import style0 from "./IdeaCoach.vue?vue&type=style&index=0&id=3c33d654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c33d654",
  null
  
)

export default component.exports